export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13566.808847f1.jpg";